export default __webpack_public_path__ + "static/media/guide29.aa06bd1d.png";